import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from './baseQueryWithAuth';

export interface EventBase {
  value: string;
  query_str: string;
  start_datetime: string;
}

export interface AdminGetPagesEventBaseResponse {
  pages: EventBase[];
}

export interface GetEventPagesForReportArgs {
  client_id: number;
}

export const eventPagesForReportApi = createApi({
  reducerPath: 'eventPagesForReportApi',
  baseQuery: baseQueryWithAuth,
  endpoints: builder => ({
    getEventPagesForReport: builder.query<
      AdminGetPagesEventBaseResponse,
      GetEventPagesForReportArgs
    >({
      query: ({ client_id }) => ({
        url: '/admin/pages/event',
        method: 'GET',
        params: { client_id },
      }),
    }),
  }),
});

export const { useGetEventPagesForReportQuery } = eventPagesForReportApi;
